import Splide from '@splidejs/splide';

if (document.querySelector('.splide__opinion')) {
    const sliders = document.querySelectorAll('.splide__opinion');

    sliders.forEach((slider) => {
        const splide = new Splide(slider, {
            type: 'loop',
            perPage: 4,
            gap: '24px',
            focus: 'center',
            pagination: false,
            arrows: true,

            breakpoints: {
                640: {
                    gap: '16px',
                    perPage: 2,
                },
            },
        });

        splide.mount();
    });
}
